AgrimarketControllers.controller('commandsController', [
    '$scope', 'enumFactory', 'colonnes', '$rootScope', '$location', 'commandService', 'parametersFactory', 'configurationFactory', 'currentUserFactory', '$routeParams', '$filter',
    function ($scope, enumFactory, colonnes, $rootScope, $location, commandService, parametersFactory, configurationFactory, currentUserFactory, $routeParams, $filter) {

        if (!$rootScope.ModuleMyAccount.Active)
            $location.path('/login');

        
    }
]);